import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLocation } from 'react-router-dom';

// Initialize PostHog once
if (import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage',
  });
}

function PostHogPageTracker() {
  const location = useLocation();
  useEffect(() => {
    posthog.capture('$pageview', { $current_url: window.location.href });
  }, [location.pathname]);
  return null;
}

function PostHogIdentifier() {
  const { user, account, isAuthenticated } = useAuth();
  useEffect(() => {
    if (isAuthenticated && user?.id) {
      posthog.identify(user.id, {
        name: user.name,
        plan: account?.plan,
      });
    } else {
      posthog.reset();
    }
  }, [isAuthenticated, user?.id, user?.name, account?.plan]);
  return null;
}

export default function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!import.meta.env.VITE_POSTHOG_KEY) {
    return <>{children}</>;
  }
  return (
    <PHProvider client={posthog}>
      <PostHogPageTracker />
      <PostHogIdentifier />
      {children}
    </PHProvider>
  );
}
